// removed by extract-text-webpack-plugin
module.exports = {"stage":"styles-stage--3Ee87"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Stage/styles.scss
// module id = 0Bm2
// module chunks = 3